import { MobileDateRangePicker } from '@mui/lab'
import { Box, Stack, TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { FieldWrapper } from './FieldWrapper'
import { get as _get } from 'lodash'

interface DateRangePickerProps {
  startText?: string
  endText?: string
  inputFormat: string
  name: string
  label?: string
  sx?: any
}

export const DateRangePickerC = (props: DateRangePickerProps) => {
  const { startText, endText, name, inputFormat, label, sx } = props
  const { formState } = useFormContext()
  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FieldWrapper error={_get(formState.errors, name)}>
          <Stack spacing={3}>
            <MobileDateRangePicker
              {...field}
              label={label}
              startText={startText}
              endText={endText}
              toolbarTitle="Selecione o intervalo de datas"
              inputFormat={inputFormat}
              cancelText="cancelar"
              renderInput={(startProps: any, endProps: any) => (
                <>
                  <TextField
                    {...startProps}
                    sx={sx}
                    size="small"
                    error={_get(formState.errors, name)}
                  />
                  <Box sx={{ mx: 2 }}> à </Box>
                  <TextField
                    {...endProps}
                    sx={sx}
                    size="small"
                    error={_get(formState.errors, name)}
                  />
                </>
              )}
            />
          </Stack>
        </FieldWrapper>
      )}
    />
  )
}
